import { $translate } from '@/utils/i18n';
export default {
    tableList: [
        {
            prop: 'prefixCode',
            label: $translate('lang.E3202103160001', { defaultText: '企业前缀' }),
            width: '100',
            tooltip: true
        },
        {
            prop: 'cnName',
            label: $translate('lang.E3202103160002', { defaultText: '企业名称' }),
            width: '150',
            tooltip: true
        },
        {
            prop: 'website',
            label: $translate('lang.E3202103160003', { defaultText: '官方地址' }),
            width: '150',
            tooltip: true
        },
        {
            prop: 'industry',
            label: $translate('lang.E3202103160004', { defaultText: '所属行业' }),
            width: '100',
            tooltip: true
        },
        {
            prop: 'officialAddress',
            label: $translate('lang.E3202103160005', { defaultText: '地址' }),
            width: '100',
            tooltip: true
        },
        {
            prop: 'enterpriseIntroduction',
            label: $translate('lang.E3202103160006', { defaultText: '企业简介' }),
            width: '200',
            tooltip: false
        },
        {
            prop: 'registrationAuthority',
            label: $translate('lang.E3202103160007', { defaultText: '注册机构' }),
            width: '150',
            tooltip: true
        },
        {
            prop: 'registerTime',
            label: $translate('lang.E3202103160008', { defaultText: '注册时间' }),
            width: '100',
            tooltip: true
        }
    ]
};
